<template>

  <section class="o-section">
    <div class="o-section__wrapper is-top-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="4a">
          <div v-for="(line, index) in copy.top" v-html="line" :key="`${line}-${index}`"></div>
        </div>
        <div ref="textB" data-scene="4b">
          <div v-for="(line, index) in copy.bottom" v-html="line" :key="`${line}-${index}`"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureC" data-scene="4c">
          <Img :src="require('@/assets/scene4/spread4_c.png')" filename="spread4_c" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="4b">
          <Img :src="require('@/assets/scene4/spread4_b.png')" filename="spread4_b" />
        </figure>

        <figure class="o-section__figure anim-scene-4" ref="figureA2" data-scene="4a">
          <Img :src="require('@/assets/scene4/spread4_a2.png')" filename="spread4_a2" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="4a">
          <Img :src="require('@/assets/scene4/spread4_a.png')" filename="spread4_a" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene4',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene4', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2],
        translateX: ['80px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureA2.querySelector('div'),
        rotate: ['0', '6deg'],
        loop: true,
        direction: 'alternate',
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['20px', '0'],
        delay: 150,
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureB,
          opacity: [0, 1],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          translateX: ['-20px', '0'],
          delay: 300,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureB,
          filter: ['blur(10px)', 'blur(0px)'],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(25px)', 'blur(0px)'],
          translateX: ['-20px', '0'],
          delay: 300,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
